import { Flex } from 'antd';
import styles from './FloatingSelect.module.scss';
import { RxCross2 } from 'react-icons/rx';
import Tooltip from '../antd-tooltip/Tooltip';
import cx from 'clsx';
import TruncateText from 'components/truncate-text';
import { IF } from 'common';

const Option = ({
  selectedOptions = [],
  option = {},
  handleChange = () => {},
  disabled = false,
  limit = 100,
  isTooltipOption = false,
}) => {
  const handleRemove = () => {
    if (disabled) return;
    handleChange(selectedOptions?.filter((opt) => opt?.value !== option?.value));
  };

  return (
    <Flex
      key={option?.value}
      justify="center"
      align="center"
      gap={4}
      className={cx(styles.selectedOption, isTooltipOption && styles.tooltipOption)}
    >
      <TruncateText text={option?.label} limit={limit} />
      <RxCross2
        style={{ flexShrink: 0, cursor: disabled ? 'not-allowed' : 'pointer' }}
        role={'button'}
        size={13}
        onClick={handleRemove}
      />
    </Flex>
  );
};

const SelectedOptions = ({
  small_height,
  handleChange = () => {},
  value: selectedOptions = [],
  inputWidth,
  disabled = false,
}) => {
  const len = selectedOptions?.reduce((acc, val) => acc + (val?.label?.length || 0) * 1.4 + 9, 0);
  const selectedCount = selectedOptions?.length;
  const showMoreOption = selectedCount !== 0 && inputWidth / 4 - len < 21;

  let t = 0;
  let hideOpt = 0;
  selectedOptions?.map((v) => {
    t = t + (v?.label?.length || 0) * 1.4 + 9;
    if (inputWidth / 4 - t < 21) {
      hideOpt++;
    }
  });

  const showOpt = selectedCount - hideOpt;

  const renderOption = (option, index, isTruncate, isTooltipOption) => (
    <Option
      key={index}
      limit={isTruncate ? 30 : undefined}
      selectedOptions={selectedOptions}
      option={option}
      handleChange={handleChange}
      disabled={disabled}
      isTooltipOption={isTooltipOption}
    />
  );

  const updatedShowOpt = showOpt === 0 ? 1 : showOpt;

  const renderSelectedOptions = (
    <Flex wrap gap={4}>
      {selectedOptions?.slice(showOpt === 0 ? 1 : showOpt)?.map((val, index) => renderOption(val, index, false, true))}
    </Flex>
  );

  return (
    <Flex gap={4} wrap className={cx(styles.selectedOptionsWrap, small_height ? styles.smallHeight : '')}>
      {selectedOptions
        ?.slice(0, showMoreOption ? updatedShowOpt : selectedCount)
        ?.map((val, index) => renderOption(val, index, showOpt === 0))}
      <IF condition={updatedShowOpt - selectedCount}>
        <IF condition={showMoreOption}>
          <Tooltip color={'var(--user-dropdown-bg)'} title={renderSelectedOptions}>
            <div className={styles.moreOptions}>+{selectedCount - updatedShowOpt}</div>
          </Tooltip>
        </IF>
      </IF>
    </Flex>
  );
};

export default SelectedOptions;
